<script setup lang="ts">
import { VIcons } from '@/shared/ui'

defineProps({
  title: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  visible: {
    type: Boolean,
    default: true,
  },
})
</script>

<template>
  <div
    class="v-content-grid-item"
    :class="{ 'v-content-grid-item_compact': compact, 'v-content-grid-item_hide': !visible }"
  >
    <div class="v-content-grid-item__header">
      <div class="monitoring-grid-item__title">
        <slot name="icon" />

        <slot name="title">
          {{ title }}
        </slot>
      </div>

      <div data-handle class="v-content-grid-item__move">
        <VIcons type="drag_pan" />
      </div>
    </div>

    <div class="monitoring-grid-item__body">
      <slot />
    </div>
  </div>
</template>
